import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { BaseResponse } from 'types/utils'

import type { Meter } from '../types'

export const metersQueryKey = ['meters']

export function useMeters({ flat }: { flat?: string }) {
  async function getMeters() {
    const response = await apiClient.get<BaseResponse<Meter>>(
      SNA_PREFIX + 'meters',
      { params: { flat, limit: 100 } }
    )

    return response.data
  }

  return useQuery({
    queryFn: getMeters,
    enabled: !!flat,
    queryKey: [...metersQueryKey, flat]
  })
}
